import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Safe = function Safe(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M6 21h3m6 0h3m-.5-14.5v8M3 6.2v8.6c0 1.1201 0 1.6802.218 2.108.1917.3763.4977.6823.874.874C4.5198 18 5.08 18 6.2 18h11.6c1.1201 0 1.6802 0 2.108-.218a2 2 0 0 0 .874-.874C21 16.4802 21 15.9201 21 14.8V6.2c0-1.1201 0-1.6802-.218-2.108a2 2 0 0 0-.874-.874C19.4802 3 18.9201 3 17.8 3H6.2c-1.1201 0-1.6802 0-2.108.218a2 2 0 0 0-.874.874C3 4.5198 3 5.08 3 6.2m8.5 4.3c0 1.3807-1.1193 2.5-2.5 2.5s-2.5-1.1193-2.5-2.5S7.6193 8 9 8s2.5 1.1193 2.5 2.5"
    })
  }));
};
export default Safe;